module.exports = __webpack_public_path__ + "img/btn_close-r.cf934ddb.svg";